export default __webpack_public_path__ + "static/media/mykulychyn.de610ef8.webp";